export default __webpack_public_path__ + "static/media/map-latam.f051ab6d.jpg";